import {ResourceType} from "../../../features/admin/components/feat-mgmt/feat-mgmt.types";

export enum EnumBillingType {
    COMPANY = "COMPANY",
    PERSONAL = "PERSONAL"
}

export class BillingInfoDTO  {
    internalOrderId: string;
    billingType: EnumBillingType;
    personalBillingId: string;
    companyBillingId: string;
}

export enum OrderStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    PENDING_PAYMENT = 'PENDING_PAYMENT',
    PAID = 'PAID',
    FINALIZED = 'FINALIZED',
    CANCELLED = 'CANCELLED'
}

export interface ProductUpdateRsp {
    id: string;
    internalOrderId: string;
    name: string;
    productCategory: string;
    price: number;
    enumCurrency: string;
    count: number;
    appModuleId: string;
    appResourceId: string;
    orderPrice: number;
}

export enum ProductCategory {
    MODULE = "MODULE",
    RESOURCE = "RESOURCE"
}

export interface CartProduct {
    id: string;
    internalOrderId: string;
    priceDetails: string;
    name: string;
    productCategory: ProductCategory;
    price: number;
    enumCurrency: string;
    count: number;
    appModuleId: string | null;
    appResourceId: string | null;
    resourceType: ResourceType;
    internalPrefixCode: string; // module internal ID
}

export interface CartModel {
    id: string;
    tenantId: string;
    totalAmount: number;
    totalAmountWithTax: number | null;
    enumCurrency: string;
    orderStatus: OrderStatus,
    paymentUrl?: string,
    products: CartItem[];
}

export interface CartItem extends CartProduct{
    icon: string;
}

export interface CartUpdateModel {
    internalOrderId: string;
    count: number;
    appModuleId: string;
    appResourceId: string;
}
